import "./contact-us.css";
import ContactForm from "../../components/contact-form/ContactForm";

function ContactUs() {
  return (
    <div className="contact-us">
      <div className="contact-us-header">
        <h1 className="animate__animated animate__fadeIn animate__slow">
          Let&apos;s make the first step and get in contact.
        </h1>
        <a href="https://mail.google.com/mail/?view=cm&to=Hi@TiMN.GE" target="_blank">Say Hello via Email</a>
      </div>
      <ContactForm color="light" phoneNumber={false} />
    </div>
  );
}

export default ContactUs;
